export default {
  app: {
    title: "Rüya Kelime Kutusu",
    language: "Rüya Kelime Kutusu"
  },

  pages: {
    app: {
      myAccount: "Hesabım",
      editProfile: "Profili Düzenle",

      boxScenarios: "Kutu Senaryoları",
      scenario1Title: "Yarım Günlük Kutu",
      scenario1Desc: "Kutuyu yarım günde bir gözden geçirin (örneğin sabah ve akşam).",

      scenario2Title: "Günlük Kutu",
      scenario2Desc: "Kutuyu günde bir kez gözden geçirin.",

      scenario3Title: "Kutu Numarası Günleri",
      scenario3Desc: "Kutuyu numarasına göre gözden geçirin (örneğin, 3. Kutu 3 günde bir).",

      username: "Kullanıcı Adı",
      usernameHint: "Giriş için benzersiz kullanıcı adınız",

      name: "İsim",
      nameHint: "Size nasıl hitap etmeliyiz?",

      email: "E-posta Adresi",
      emailHint: "Şifre kurtarma için e-posta (isteğe bağlı)",

      changePassword: "Şifreyi Değiştir",
      changePasswordHint: "Şifrenizi değiştirmek istemiyorsanız bu alanı boş bırakın (isteğe bağlı)",

      logout: "Çıkış Yap",
      confirmLogout: "Çıkışı Onayla",
      confirmLogoutText: "Çıkış yapmak istediğinize emin misiniz?",
      cancel: "İptal",

      close: "Kapat",
      updateProfile: "Profili Güncelle",

      myWords: "Kelimelerim",
      addNewWord: "Yeni Kelime/Deyim Ekle",
      boxes: "Kutular",

      applicationSettings: "Uygulama Ayarları",

      autoSpeechOnChecking: "Kelime gösterilmeye başlandığında otomatik seslendir",
      autoDetectClipboardChange: "Pano metnini otomatik algıla",

      clipboardPermissionText: "Uygulamanın pano erişimi için tarayıcı ayarlarından izin alması gerekiyor. Daha fazla yardım için buraya tıklayın.",

      clipboardHelpTitle: "Pano Erişimini Etkinleştirme",

      chrome: "Chrome",
      firefox: "Firefox",
      safari: "Safari",

      chromeStep1: "Chrome tarayıcısını açın.",
      chromeStep2: "Tarayıcı ayarlarına gidin.",
      chromeStep3: "Site Ayarları veya Ayarlar bölümünü bulun.",
      chromeStep4: "İzinler kısmına gidip Pano'yu etkinleştirin.",

      firefoxStep1: "Firefox tarayıcısını açın.",
      firefoxStep2: "Tarayıcı Ayarlarına gidin.",
      firefoxStep3: "İzinler bölümünü bulun ve pano erişimini etkinleştirin.",

      safariStep1: "Telefonunuzun Ayarlar uygulamasını açın.",
      safariStep2: "Safari'ye gidin.",
      safariStep3: "Pano ile ilgili ayarları bulun ve etkinleştirin.",

      otherBrowserTitle: "Başka bir tarayıcı kullanıyorsanız",
      otherBrowserStep1: "Tarayıcı ayarlarında benzer bir İzinler veya Site Ayarları seçeneği arayın ve pano erişimini etkinleştirin.",

      speechNotSupported: "Tarayıcınız SpeechSynthesis özelliğini desteklemiyor",

      ttsSettings: "Metin Okuma Ayarları",
      sampleText: "Ses testi için örnek metin",

      rate: "Hız",
      rateHint: "Konuşma hızını ayarlar.",

      pitch: "Ses Tonu",
      pitchHint: "Sesin tonunu ayarlar.",

      volume: "Ses Seviyesi",
      volumeHint: "Konuşma ses seviyesini ayarlar.",

      friends: "Arkadaşlar",
      messages: "Mesajlar",

      addToMyWords: "{word} kelimesini Kelimelerim'e ekle",
      viewInMyList: "{word} kelimesini listemde gör",

      wordSuggestion: "Kelime Önerisi",
      goToAddWord: "Yeni Kelime Ekleme Sayfasına Git",

      updateCompleted: "Güncelleme başarıyla tamamlandı",
      latestChanges: "Son sürümlerdeki yeni değişiklikler",
      version: "Sürüm",
      gotIt: "Anladım"
    },

    addVocabulary: {
      title: "Yeni Kelime Ekle",
      add: "Ekle",
      word: "Kelime / İfade",
      meaning: "Anlamı",
      example: "Örnek Cümle",
      description: "Açıklama"
    },

    vocabularies: {
      searchLabel: "Metin ara",
      listLength: "Liste Uzunluğu",
      boxNumber: "Kutu Numarası",
      nothingFound: "Hiçbir şey bulunamadı !!!",
      adjustFilters: "Lütfen filtrelerinizi ayarlamayı deneyin",
      tableWord: "Kelime",
      tableAction: "İşlem",
      showDetails: "Detayları Göster",
      completeInfo: "Tüm Bilgiler",
      meaning: "Anlamı",
      example: "Örnek Cümle",
      description: "Açıklama",
      close: "Kapat",
      editTitle: "Düzenle",
      editBtn: "Düzenle",
      deleteTitle: "{word} kelimesini sil",
      deleteConfirmText: "Bu kelimeyi silmek istediğinize emin misiniz? Silindikten sonra geri yüklenemeyeceğini lütfen unutmayın.",
      yes: "Evet!",
      no: "Hayır"
    },

    messages: {
      wordSuggestions: "Kelime Önerileri"
    },

    login: {
      signInTitle: "Giriş Yap",
      signInBtn: "Giriş Yap",
      registerTitle: "Kayıt Ol",
      registerBtn: "Kayıt Ol",
      registerLink: "Kayıt Ol",
      username: "Kullanıcı Adı",
      password: "Şifre",
      nickname: "İsim",
      email: "E-posta Adresi",
      noAccount: "Henüz kayıt olmadınız mı?",
      haveAccount: "Zaten hesabım var.",
      usernameHint: "Giriş için benzersiz kullanıcı adınız",
      nicknameHint: "Size nasıl hitap etmeliyiz?",
      emailHint: "Şifre kurtarma için e-posta (isteğe bağlı)",
      passwordHint: "Kural gerektirmeyen şifre, istediğinizi yazın",
      orContinueWith: "Veya şununla devam et...",
      guestRegister: "Misafir Olarak Hızlı Kayıt 😒"
    },

    reviewVocabulary: {
      showMeaning: "Anlamını Göster",
      hideMeaning: "Anlamını Gizle",
      meaning: "Anlamı",
      example: "Örnek Cümle",
      description: "Açıklama",
      playPhrase: "PlayPhrase.me",
      prev: "Önceki",
      next: "Sonraki"
    },

    checkVocabulary: {
      showMeaning: "Anlamını Göster",
      hideMeaning: "Anlamını Gizle",
      wordsRemain: "Kalan Kelimeler",
      lastOne: "Son Kelime",
      meaning: "Anlamı",
      example: "Örnek Cümle",
      description: "Açıklama",
      playPhrase: "PlayPhrase.me",
      iRemember: "Hatırlıyorum",
      iDontRemember: "Hatırlamıyorum"
    },

    boxes: {
      all: "Tüm kutuları göster",
      box: "Kutu",
      empty: "Boş",
      needsChecking: "Kontrol Edilmeli",
      checked: "Kontrol Edildi",

      total: "Toplam",
      waiting: "Bekleyen",
      waitingForCheck: "Kontrol bekliyor",

      closestReview: "En yakın gözden geçirme",
      notScheduled: "Henüz planlanmadı",

      deeplyMemorized: "{count} kelimeyi tamamen hafızanıza kazıdınız.",
      notReachedYet: "Hoppala! Henüz bu kutuya ulaşmadınız.",

      startChecking: "Kontrolü Başlat",
      review: "Gözden Geçir",
      viewAllWords: "Tüm Kelimeleri Gör",
      addNew: "Yeni Ekle",
      itsEmpty: "Kutu Boş"
    },

    friends: {
      searchInUsers: "Kullanıcılarda ara",
      searchList: "Arama Listesi",
      noUsersYet: "Henüz kullanıcı bulunmuyor.",
      searchUsersAndSendRequest: "Kullanıcıları arayabilir ve arkadaşlık isteği gönderebilirsiniz",
      friendList: "Arkadaş Listesi",
      noFriendsYet: "Henüz arkadaşınız bulunmuyor."
    }
  },

  plugins: {
    axios: {
      postRequestError: "İstek gönderilirken bir hata oluştu"
    }
  },

  components: {
    shareButton: {
      shareTitle: "{word} kelimesini paylaş",
      messageOptional: "Mesaj (İsteğe bağlı)"
    },

    userList: {
      cancelRequest: "İsteği İptal Et",
      unfriend: "Arkadaşlıktan Çıkar",
      sendRequest: "İstek Gönder",
      accept: "Kabul Et",
      reject: "Reddet",

      share: "Paylaş",
      addedBefore: "Daha önce eklenmiş",

      deeplyMemorized: "{name}, {count} kelimeyi tamamen hafızasına kazıdı.",
      notReachedBox: "{name} henüz bu kutuya ulaşmadı.",

      totalVocabularies: "Toplam Kelimeler",
      registerAge: "Kayıt Süresi",
      lastCheck: "Son Kontrol",
      lastAddedVocabulary: "Son Eklenen Kelime",
      totalChecks: "Toplam Kontrol Sayısı",
      averageDailyCheck: "Günlük Ortalama Kontrol",
      averageDailyLearnedCheck: "Günlük Ortalama Öğrenilen Kelime",
      averageDailyNotLearnedCheck: "Günlük Ortalama Öğrenilmeyen Kelime",
      averageDailyAdd: "Günlük Ortalama Eklenen Kelime"
    }
  },

  public: {
    close: "Kapat"
  },
  "apiResultStatusCodes": {
    "0": "İşlem başarısız oldu",
    "1": "İşlem başarılı",
    "2": "Bir hata oluştu",
    "3": "Gönderilen parametreler geçersiz",
    "4": "Bulunamadı",
    "5": "Kimlik doğrulama hatası",
    "6": "Bu öğe zaten kayıtlı",
    "7": "Bu kullanıcı zaten kayıtlı",
    "8": "Belirtilen kullanıcı mevcut değil",
    "9": "Yanlış şifre",
    "10": "Geçersiz parametreler",
    "11": "Giriş başarısız",
    "12": "Erişim reddedildi",
    "13": "Öğe bulunamadı",
    "14": "Bu kullanıcı adı zaten alınmış",
    "15": "Bu e‑posta zaten kullanılıyor",
    "16": "Kullanıcı adı gereklidir",
    "17": "Takma ad gereklidir",
    "18": "Şifre gereklidir",
    "19": "Kullanıcı adı boşluk içeremez",
    "20": "Kayıt başarıyla tamamlandı",
    "21": "Giriş başarıyla tamamlandı",
    "22": "Şifre boşluk içeremez",
    "23": "Kelime başarıyla eklendi",
    "24": "Kelime başarıyla güncellendi",
    "25": "Kelime başarıyla silindi",
    "26": "Bu kelimeyi zaten eklediniz",
    "27": "Kelime zorunludur",
    "28": "Hiç kelime bulunamadı",
    "29": "Tebrikler! Bu kutudaki tüm kelimeler kontrol edildi",
    "30": "Kelime alanını değiştiremezsiniz",
    "31": "Lütfen gerekli alanları doldurun",
    "32": "Herhangi bir değişiklik bulunamadı",
    "33": "Belirtilen kullanıcı depoda bulunamadı",
    "34": "Arkadaşlık isteği başarıyla gönderildi",
    "35": "Arkadaşlık isteği başarıyla kabul edildi",
    "36": "Arkadaşlık isteği başarıyla iptal edildi",
    "37": "Arkadaşlıktan başarıyla çıkarıldı",
    "38": "İstek başarıyla reddedildi",
    "39": "Mesaj başarıyla gönderildi"
  },
  "time": {
    "day": "gün",
    "hour": "saat",
    "minute": "dakika"
  }

}
